// Flat catalog — organized by machine type + working height / capacity.
// Photos live under /app/frontend/public/machines/

const IMG = (name) => `/machines/${name}`;

export const allMachinesRaw = [
  // ─── 1. TRANSPORTE (primera máquina) ────────────────────────────────────
  {
    id: "transporte-camion-grua",
    name: "Camión grúa porta vehículos y portamaquinaria",
    description:
      "Se hacen portes de vehículos y maquinaria (plataforma deslizante). Carga máxima: 6.500 kg.",
    image: IMG("new-camion-grua.jpg"),
    iconName: "Truck",
  },

  // ─── 2. PLATAFORMAS ARTICULADAS (por altura) ────────────────────────────
  {
    id: "articulada-16m",
    name: "Plataforma articulada 16 m diésel",
    description:
      "Plataforma articulada diésel todoterreno de 16 m. Ideal para exteriores, fachadas y obras en terreno irregular con gran altura de trabajo.",
    image: IMG("new-img-003.jpg"),
    iconName: "MoveVertical",
  },
  {
    id: "articulada-18m",
    name: "Plataforma articulada 18 m diésel",
    description:
      "Plataforma articulada diésel todoterreno de 18 m con brazo pluma. Alcance amplio para fachadas, mantenimiento industrial y obra pública.",
    image: IMG("new-plataforma-18m.jpg"),
    iconName: "MoveVertical",
  },
  {
    id: "articulada-20m",
    name: "Plataforma articulada 20 m diésel",
    description:
      "Plataforma articulada diésel autopropulsada de 20 m de altura de trabajo. Todoterreno y de gran alcance, ideal para exteriores, fachadas y mantenimiento industrial.",
    image: IMG("new-plataforma-20m-diesel.jpg"),
    iconName: "MoveVertical",
  },

  // ─── 3. PLATAFORMAS DE TIJERA ELÉCTRICAS (8, 10, 12) ────────────────────
  {
    id: "tijera-elec-8m",
    name: "Plataforma de tijera 8 m eléctrica",
    description:
      "Tijera eléctrica compacta de 8 m de altura de trabajo. Silenciosa y sin emisiones, ideal para interiores, naves y trabajos ligeros en altura.",
    image: IMG("img-019.jpg"),
    iconName: "MoveVertical",
  },
  {
    id: "tijera-elec-10m",
    name: "Plataforma de tijera 10 m eléctrica",
    description:
      "Tijera eléctrica compacta de 10 m de altura de trabajo. Silenciosa, sin emisiones y muy maniobrable para pasillos estrechos y trabajos interiores.",
    image: IMG("img-019.jpg"),
    iconName: "MoveVertical",
  },
  {
    id: "tijera-elec-12m",
    name: "Plataforma de tijera 12 m eléctrica",
    description:
      "Tijera eléctrica compacta de 12 m con plataforma amplia y extensión telescópica. Ideal para trabajos prolongados en altura en interiores.",
    image: IMG("img-019.jpg"),
    iconName: "MoveVertical",
  },

  // ─── 4. PLATAFORMAS DE TIJERA DIÉSEL (10, 12, 18) ───────────────────────
  {
    id: "tijera-diesel-10m",
    name: "Plataforma de tijera 10 m diésel",
    description:
      "Tijera diésel de 10 m para trabajos en exterior. Sistema autonivelante y estabilizadores para superficies con desnivel.",
    image: IMG("img-008.jpg"),
    iconName: "MoveVertical",
  },
  {
    id: "tijera-diesel-12m",
    name: "Plataforma de tijera 12 m diésel 4x4",
    description:
      "Tijera diésel todoterreno de 12 m con tracción 4x4, autonivelación y estabilizadores. Ideal para trabajos en altura en exteriores y terrenos irregulares.",
    image: IMG("new-img-001.jpg"),
    iconName: "MoveVertical",
  },
  {
    id: "tijera-diesel-18m",
    name: "Plataforma de tijera 18 m diésel",
    description:
      "Tijera diésel todoterreno de 18 m con estabilizadores. Gran capacidad de trabajo en altura para fachadas, obra pública y proyectos industriales en exteriores.",
    image: IMG("new-plataforma-18m-diesel.png"),
    iconName: "MoveVertical",
  },

  // ─── 5. EXCAVADORAS Y CARGADORAS (menor a mayor) ────────────────────────
  {
    id: "excav-miniretro-jcb-1cx",
    name: "Miniretroexcavadora JCB 1CX",
    description:
      "Miniretroexcavadora mixta compacta y versátil. Ideal para excavaciones, carga de materiales y trabajos en espacios reducidos.",
    image: IMG("img-006.jpg"),
    iconName: "Construction",
  },
  {
    id: "excav-mini-giratoria-5t",
    name: "Miniexcavadora giratoria 5 t",
    description:
      "Miniexcavadora sobre orugas con cabina cerrada. Excelente relación tamaño-fuerza para zanjas, canalizaciones y movimientos de tierra medianos.",
    image: IMG("img-009.jpg"),
    iconName: "Construction",
  },
  {
    id: "excav-mini-giratoria-27",
    name: "Miniexcavadora giratoria 2,7 t",
    description:
      "Miniexcavadora compacta de giro completo y 2,7 t. Perfecta para trabajar pegado a muros y espacios estrechos, con cabina climatizada y control preciso.",
    image: IMG("img-012.jpg"),
    iconName: "Construction",
  },
  {
    id: "excav-minicargadora",
    name: "Minicargadora",
    description:
      "Minicargadora compacta y maniobrable. Ideal para trabajos en espacios reducidos, carga de materiales, nivelado y transporte en obra.",
    image: IMG("new-minicargadora-bobcat.jpg"),
    iconName: "Construction",
  },
  {
    id: "excav-manipulador-4m",
    name: "Manipulador telescópico 4 metros",
    description:
      "Manipulador telescópico compacto con brazo de 4 metros. Elevar, transportar y colocar cargas con precisión y seguridad en obras y almacenes.",
    image: IMG("img-025.jpg"),
    iconName: "Forklift",
  },
  {
    id: "excav-minipala-cargadora",
    name: "Minipala cargadora",
    description:
      "Minipala cargadora articulada con cazo frontal. Máquina compacta que pesa 2.000 kg, ideal para carga de materiales, movimiento de tierras y trabajo en obra.",
    image: IMG("new-pala-cargadora.png"),
    iconName: "Construction",
  },

  // ─── 6. COMPACTACIÓN Y OBRA ─────────────────────────────────────────────
  {
    id: "compact-dumper-1500",
    name: "Dumper 1.500 kg",
    description:
      "Dumper todoterreno con tracción a las cuatro ruedas y volquete giratorio. Ideal para transportar tierra, escombros y grava en obra.",
    image: IMG("new-dumper.jpg"),
    iconName: "Truck",
  },
  {
    id: "compact-rodillo-tandem",
    name: "Rodillo tándem",
    description:
      "Rodillo tándem vibratorio de doble tambor. Compactación uniforme de asfalto, zahorras y firmes con gran maniobrabilidad.",
    image: IMG("img-001.jpg"),
    iconName: "Cylinder",
  },
  {
    id: "compact-plancha-vibradora",
    name: "Plancha vibradora reversible",
    description:
      "Plancha vibradora reversible para compactación de suelos, gravas y zahorras. Marcha adelante y atrás para zanjas y áreas confinadas.",
    image: IMG("new-placa-vibratoria.jpg"),
    iconName: "Cylinder",
  },
  {
    id: "compact-pison-rana",
    name: "Pisón compactador (rana)",
    description:
      "Pisón compactador de percusión (rana) con motor de gasolina. Ideal para compactar suelos cohesivos en zanjas, arquetas y espacios estrechos donde no llega la plancha.",
    image: IMG("new-pison-rana.jpg"),
    iconName: "Cylinder",
  },
  {
    id: "compact-hormigonera",
    name: "Hormigonera eléctrica",
    description:
      "Hormigonera eléctrica sobre chasis con ruedas para amasado de hormigón, mortero y aglomerados. Robusta, fácil de mover y de vaciado cómodo en obra.",
    image: IMG("new-hormigonera.jpg"),
    iconName: "Cylinder",
  },
  {
    id: "compact-pistolete",
    name: "Martillo demoledor",
    description:
      "Pistolete eléctrico de gran potencia para demolición y picado en hormigón, asfalto y mampostería. Alto rendimiento con control preciso para trabajos de obra.",
    image: IMG("new-pistolete.jpg"),
    iconName: "Construction",
  },
  {
    id: "compact-cortadora-juntas",
    name: "Cortadora de suelo",
    description:
      "Cortadora de suelo con motor de gasolina para juntas y cortes precisos en asfalto y hormigón. Ideal para obra pública, urbanización y trabajos de pavimentación.",
    image: IMG("new-cortadora-suelo-wacker.jpg"),
    iconName: "Scissors",
  },

  // ─── 7. GENERADORES (por kVA ascendente) ────────────────────────────────
  {
    id: "gen-monofasico-trifasico-2000w",
    name: "Generadores monofásicos y trifásicos desde 2.000 W",
    description:
      "Generadores portátiles monofásicos y trifásicos desde 2.000 W. Suministro eléctrico versátil para herramientas de obra, pequeños eventos y aplicaciones domésticas o profesionales.",
    image: IMG("new-generador-pramac.jpg"),
    iconName: "Zap",
  },
  {
    id: "gen-30",
    name: "Generador 30 kVA",
    description:
      "Grupo electrógeno diésel de 30 kVA. Compacto y silencioso, ideal para obras pequeñas, eventos y aplicaciones que requieran suministro estable.",
    image: IMG("new-generador-rojo.jpg"),
    iconName: "Zap",
  },
  {
    id: "gen-60",
    name: "Generador 60 kVA",
    description:
      "Grupo electrógeno diésel de 60 kVA. Buena relación potencia-consumo para obra media, herramientas eléctricas simultáneas y respaldo temporal.",
    image: IMG("new-generador-rojo.jpg"),
    iconName: "Zap",
  },
  {
    id: "gen-100",
    name: "Generador 100 kVA",
    description:
      "Grupo electrógeno insonorizado de 100 kVA. Suministro eléctrico estable y de alta autonomía para obras, eventos y aplicaciones industriales.",
    image: IMG("img-021.jpg"),
    iconName: "Zap",
  },
  {
    id: "gen-180",
    name: "Generador 180 kVA",
    description:
      "Grupo electrógeno de gran potencia. Suministro robusto y fiable para obras de gran envergadura, naves industriales y aplicaciones exigentes.",
    image: IMG("new-generador-rojo.jpg"),
    iconName: "Zap",
  },

  // ─── 8. CARRETILLAS ELEVADORAS (por capacidad ascendente) ───────────────
  {
    id: "cart-elec-1600",
    name: "Carretilla elevadora eléctrica 1.600 kg",
    description:
      "Carretilla elevadora eléctrica de 1.600 kg con cabina. Precisa y eficiente para la manipulación de mercancías en naves y almacenes.",
    image: IMG("img-020.jpg"),
    iconName: "Forklift",
  },
  {
    id: "cart-diesel-1800",
    name: "Carretilla elevadora diésel 1.800 kg",
    description:
      "Carretilla elevadora diésel con cabina cerrada. Robusta y potente para trabajo continuo en exterior, cargas pesadas y obras.",
    image: IMG("img-018.jpg"),
    iconName: "Forklift",
  },
  {
    id: "cart-elec-2000",
    name: "Carretilla elevadora eléctrica 2.000 kg",
    description:
      "Carretilla elevadora eléctrica de 2.000 kg. Cero emisiones, funcionamiento silencioso y gran maniobrabilidad para naves, almacenes y logística.",
    image: IMG("img-015.jpg"),
    iconName: "Forklift",
  },
  {
    id: "cart-elec-3500",
    name: "Carretilla elevadora eléctrica 3.500 kg",
    description:
      "Carretilla elevadora eléctrica de litio de 3.500 kg. Cero emisiones, funcionamiento silencioso y gran maniobrabilidad para naves y logística.",
    image: IMG("new-img-002.jpg"),
    iconName: "Forklift",
  },
  {
    id: "cart-diesel-7000",
    name: "Carretilla elevadora diésel 7.000 kg",
    description:
      "Carretilla elevadora diésel de gran capacidad. Ideal para cargas muy pesadas en industria, logística y contenedores.",
    image: IMG("new-hyster-7.jpg"),
    iconName: "Forklift",
  },
  {
    id: "cart-todoterreno-4x4",
    name: "Carretilla todoterreno 4x4",
    description:
      "Carretilla elevadora todoterreno con tracción 4x4 y cabina cerrada. Robusta y estable para obras, cargas pesadas y superficies irregulares.",
    image: IMG("new-img-000.jpg"),
    iconName: "Forklift",
  },

  // ─── 9. BOMBAS ──────────────────────────────────────────────────────────
  {
    id: "bomba-sumergible",
    name: "Bomba sumergible",
    description:
      "Bomba sumergible eléctrica para achique y trasvase de aguas en obra, sótanos, zanjas y drenajes. Robusta y de alto caudal.",
    image: IMG("new-bomba-sumergible.jpg"),
    iconName: "Wind",
  },

  // ─── 10. JARDINERÍA (autopropulsada primero, sin duplicados) ────────────
  {
    id: "jard-desbrozadora-autopropulsada",
    name: "Desbrozadora autopropulsada",
    description:
      "Desbrozadora autopropulsada de rodillos con motor de gasolina. Corta hierba alta, cañas y maleza densa en terrenos irregulares con gran rendimiento.",
    image: IMG("new-desbrozadora-autoprop.jpg"),
    iconName: "Scissors",
  },
  {
    id: "jard-desbrozadora-profesional",
    name: "Desbrozadora",
    description:
      "Desbrozadora profesional con manillar y disco de tres puntas. Potente y ergonómica para matorral denso, cañas y trabajos forestales prolongados.",
    image: IMG("img-003.jpg"),
    iconName: "Scissors",
  },
  {
    id: "jard-cortacesped",
    name: "Cortacésped profesional",
    description:
      "Cortacésped autopropulsado con saco recolector. Corte limpio y uniforme para mantenimiento de jardines y zonas verdes.",
    image: IMG("img-005.jpg"),
    iconName: "Scissors",
  },

  // ─── 11. LIMPIEZA ───────────────────────────────────────────────────────
  {
    id: "limp-hidro-electrica",
    name: "Hidrolimpiadora eléctrica agua fría",
    description:
      "Hidrolimpiadora eléctrica de agua fría, alta presión y enrollacables integrado. Limpieza rápida de vehículos, patios y superficies exteriores.",
    image: IMG("img-022.jpg"),
    iconName: "Wind",
  },
  {
    id: "limp-hidro-profesional",
    name: "Hidrolimpiadora profesional agua fría",
    description:
      "Hidrolimpiadora profesional de agua fría con carro. Ideal para talleres, obras y flotas donde se requiere uso intensivo continuado.",
    image: IMG("img-023.jpg"),
    iconName: "Wind",
  },
  {
    id: "limp-hidro-caliente",
    name: "Hidrolimpiadora agua caliente",
    description:
      "Hidrolimpiadora profesional de agua caliente. Elimina grasa y suciedad incrustada en talleres, cocinas industriales y maquinaria pesada.",
    image: IMG("img-024.jpg"),
    iconName: "Wind",
  },
  {
    id: "limp-aspirador",
    name: "Aspirador industrial",
    description:
      "Aspirador industrial de sólidos y líquidos. Alta capacidad, potencia constante y sistema de recogida móvil para trabajos en obra, taller e industria.",
    image: IMG("img-000.jpg"),
    iconName: "Wind",
  },
  {
    id: "limp-barredora",
    name: "Barredora manual",
    description:
      "Barredora de empuje manual con doble cepillo lateral. Limpieza rápida y eficiente de patios, naves, aparcamientos y aceras sin electricidad.",
    image: IMG("img-010.jpg"),
    iconName: "Wind",
  },
];

// Category ordering for display (stable within each bucket)
const CATEGORY_ORDER = [
  "transporte-",
  "articulada-",
  "tijera-elec-",
  "tijera-diesel-",
  "excav-",
  "compact-",
  "gen-",
  "cart-",
  "bomba-",
  "jard-",
  "limp-",
];

const _catRank = (id) => {
  const i = CATEGORY_ORDER.findIndex((p) => id.startsWith(p));
  return i === -1 ? 999 : i;
};
export const allMachines = [...allMachinesRaw].sort(
  (a, b) => _catRank(a.id) - _catRank(b.id)
);

// Legacy helpers kept as stubs to avoid breaking other imports
export const categories = [];
export const getCategoryById = () => null;
export const getMinPrice = () => 0;
export const getGlobalMinPrice = () => 0;

export const contactInfo = {
  phone: "614 565 479",
  phoneRaw: "+34614565479",
  whatsapp: "34652960814",
  phone2: "652 96 08 14",
  phone2Raw: "+34652960814",
  email: "maquinariasantacruz@yahoo.com",
  address: "Polígono Industrial S, 30 P, Santa Olalla (Toledo)",
  addressLine1: "Polígono Industrial S, 30 P",
  addressLine2: "Santa Olalla (Toledo)",
  mapLat: 40.034667,
  mapLng: -4.417033,
  mapQuery: "Polígono Industrial S 30 P, 45530 Santa Olalla, Toledo",
  schedule: "Lun–Vie 07:00–15:00",
  companyName: "Maquinaria Santacruz",
};
